/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Claim_Id_TakenInputs */

const en_error_claim_id_taken = /** @type {(inputs: Error_Claim_Id_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This claim was already sent. Open your claims to find it.`)
};

/**
* | output |
* | --- |
* | "This claim was already sent. Open your claims to find it." |
*
* @param {Error_Claim_Id_TakenInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_claim_id_taken = /** @type {((inputs?: Error_Claim_Id_TakenInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Claim_Id_TakenInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_claim_id_taken(inputs)
});